import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './self-service-item.component.scss';
var SelfServiceItem = /** @class */ (function (_super) {
    tslib_1.__extends(SelfServiceItem, _super);
    function SelfServiceItem(element) {
        return _super.call(this, element) || this;
    }
    SelfServiceItem.prototype.init = function () { };
    SelfServiceItem.prototype.bindEvents = function () { };
    return SelfServiceItem;
}(Base));
export { SelfServiceItem };



//////////////////
// WEBPACK FOOTER
// ./components/self-service-item/self-service-item.component.ts
// module id = 494
// module chunks = 0